import client from './api-client';

export const postIniciarSesion = async(body) => {
    try {
        
        const response = await client.post('login', body);
        //console.log(response);

        if (response.status === 200) {

            if (response.data.code === 1) {
                
                localStorage.setItem("user", JSON.stringify(response.data.object));
                return { user: response.data.object };

            } else {

                return { message: response.data.message };
            }
            
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const postCerrarSesion = async() => {
    try {
        
        localStorage.removeItem("user");

    } catch(error){
        throw error;
    }
}

export const postRefrescarToken = async(body) => {
    try {
        
        const response = await client.post('refreshtoken', body);
        //console.log(response);

        if (response.status === 200 && response.data.code === 1) {
            
            if (response.data.object.accessToken) {
                localStorage.setItem("user", JSON.stringify(response.data.object));
            }

            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const postGestionaCambioPassword = async(body) => {
    try {
        
        const response = await client.post('cambio-password', body);
        if (response.status === 200) {
            if (response.data.code === 1) {                
                return { data: response.data };
            } else {
                return { message: response.data.message };
            }
        } else {
            throw new Error(response.data.message);
        }
    } catch(error){
        throw error;
    }
}